export default function Dropdown({
  dropdownOptions,
  handleSelectedChange,
  selectMessage,
  selectClassName,
  defaultValue,
  handleArgs
}) {
  return (
    <>
      <select
        className={selectClassName}
        value={defaultValue}
        onChange={(e) => {
          handleSelectedChange(...handleArgs, e.target.value);
        }}
      >
        <option key='' value=''>
          {selectMessage}
        </option>
        {Object.keys(dropdownOptions).map((key) => (
          <option key={key} value={dropdownOptions[key]}>
            {key}
          </option>
        ))}
      </select>
    </>
  );
}
